import { render, staticRenderFns } from "./AboutYou.vue?vue&type=template&id=00d9f792"
import script from "./AboutYou.vue?vue&type=script&lang=js"
export * from "./AboutYou.vue?vue&type=script&lang=js"
import style0 from "./AboutYou.vue?vue&type=style&index=0&id=00d9f792&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports